import React, { useState, useEffect } from 'react';
import Header from './header';
import Banner from './banner';
import About from './about';
import PricingPlans from './pricingplans';
import ContactForm from './contactform';
import Footer from './footer';
import WorkProcess from './workprecess';
import KeyBenefits from './keybenefits';
import WhyKnackHire from './whyknackhir';
import Tour from './tour';
const LandingPage = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
 
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
 
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
 
  useEffect(() => {
    const scrollToSectionFromHash = () => {
      const hash = window.location.hash;
      if (hash) {
        const targetSection = document.querySelector(hash);
        if (targetSection) {
          targetSection.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };
 
    scrollToSectionFromHash();
    window.addEventListener('load', scrollToSectionFromHash);
    return () => window.removeEventListener('load', scrollToSectionFromHash);
  }, []);
 
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
 
 
 
  return (
    <div>
      <div id="Home">
        <Header />
      </div>      
      <Banner />
 
      <div id="About">
        <About />
      </div>
     
      <div id="WorkProcess">
     <WorkProcess/>
     </div>
      <div id="Keybenefits">
        <KeyBenefits/>
      </div>
 
      <div id="WhyKnackHire">
     <WhyKnackHire/>
     </div>
 
      <div id="PricingPlans">
        <PricingPlans />
      </div>
 
      <div id="Help">
        <ContactForm />
      </div>
      <div id="Tour">
        <Tour />
      </div>
      <Footer />
 
      {/* Scroll to Top Button */}
       {isVisible && (
        <div className="scroll-to-top">
          <button onClick={scrollToTop} className="button-nav" aria-label="Scroll to top">
            <i className="fa fa-arrow-up" style={{ fontSize: '24px', color: '#0070C0' }} aria-hidden="true"></i>
          </button>
        </div>
      )}
 
      <style jsx>{`
        .scroll-to-top {
          position: fixed;
          bottom: 20px;
          right: 20px;
          z-index: 1000;
          display: flex;
          justify-content: center;
          align-items: center;
        }
 
        .button-nav {
          background-color: white;
          border: 2px solid #00a7ac;
          border-radius: 10%;
          padding: 10px;
          cursor: pointer;
          box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
        }
 
        .button-nav:hover {
          background-color: #00a7ac;
          color: white;
        }
      `}</style>
    </div>
  );
};
 
 
export default LandingPage;